/**
 * sessionStorage的基本操作
 * @author 严俊华
 */
export const STORAGE_KEY = { sessionStore: '__session_store__' };
const STORAGE = sessionStorage;
function settingStorage(prefix) {
    let storage = getObjFromStorage();
    return {
        get(key) {
            return key ? storage[key] : undefined;
        },
        setAll(sourceData) {
            storage = sourceData;
            STORAGE.setItem(prefix, JSON.stringify(storage));
        },
        set(key, value) {
            storage[key] = value;
            STORAGE.setItem(prefix, JSON.stringify(storage));
        },
        clear(keyArr) {
            if (keyArr.length === 0) {
                storage = {};
                STORAGE.setItem(prefix, '{}');
            }
            else {
                keyArr.forEach((key) => {
                    delete storage[key];
                });
                STORAGE.setItem(prefix, JSON.stringify(storage));
            }
        },
    };
}
export function createStorage(prefix) {
    return settingStorage(prefix);
}
export function getObjFromStorage(prefix = STORAGE_KEY.sessionStore) {
    /** @type {Record<string, any>} */
    let storageData = STORAGE.getItem(prefix);
    storageData = storageData && storageData !== '[object Object]' ? JSON.parse(storageData) : {};
    return storageData;
}
export const storage = createStorage(STORAGE_KEY.sessionStore);
export default storage;
